<template>
  <div class="sm-list__popup-upload">
    <h4 v-if="title">{{title}}</h4>
    <upload-file
      :name="'scan'"
      :types="settings.types"
      :typesText="settings.typesText"
      :noSave="true"
      @upload="addScan"
    />
    <template v-if="uploadedScans.length">
      <ul class="sm-list__popup-upload-list">
        <li
          v-for="scan in uploadedScans"
          :key="scan.id"
            class="sm-list__popup-upload-list-item"
        >
          <div class="sm-list__popup-upload-list-item-img">
            <img
              v-if="scan.preview && scan.preview != 'pdf' && !scan.isNewImgType" 
              :src="scan.preview" 
              :alt="scan.file.name"
            />
            <include-svg
              v-else
              :name="successIcon"
            />
          </div>
          <text-truncate :text="scan.file.name" />
          <span class="sm-small disabled">{{scan.size}}</span>
          <a 
            href="#"
            class="sm-list__popup-upload-list-item-remove"
            @click.prevent="removeScan(scan.id)"
          ></a>
        </li>
      </ul>
      <btn-block
        :type="'small'"
        :text="'Submit'"
        @click="$emit('confirm', uploadedScans)"
      />
    </template>
  </div>
</template>

<script>
import UploadFile from '@/components/UploadFile';
import {FormatBytes} from '@/utils/files';

export default {
  name: 'upload-scans',
  components: {
    'upload-file': UploadFile,
  },
  props: {
    title: {
      type: String,
      default: 'Upload mail scan',
    },
    settings: {
      type: Object,
      default: () => new Object()
    },
    multipleFiles: {
      type: Boolean,
      default: true,
    },
    successIcon: {
      type: String,
      default: 'icon-upload-success'
    }
  },
  data() {
    return {
      uploadedScans: []
    }
  },
  methods: {
    addScan(file, preview) {
      const newFile = {
        size: FormatBytes(file.size),
        id: new Date().getTime(), 
        preview: file.type == 'application/pdf' ? 'pdf' : preview,
        isNewImgType: file.type == 'image/heic' || file.type == 'image/heif',
        file,
      }
      if(!this.multipleFiles) this.uploadedScans = [newFile];
      else this.uploadedScans.push(newFile);
    },
    removeScan(id) {
      const index = this.uploadedScans.findIndex(scan => scan.id == id);
      this.uploadedScans.splice(index, 1);
    },
  }
}
</script>